module.exports = __webpack_public_path__ + "img/sepa-preview.4abbb917.png";